export const WarningIconColored = props => (
  <svg width='70' height='70' viewBox='0 0 70 70' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx='35' cy='35' r='35' fill='#FBEDE1' />
    <path
      d='M34.9999 28V35M34.9999 42H35.0174M32.0074 19.005L17.1849 43.75C16.8792 44.2792 16.7175 44.8793 16.7158 45.4904C16.7141 46.1015 16.8725 46.7025 17.1751 47.2334C17.4777 47.7644 17.9141 48.2068 18.4408 48.5167C18.9676 48.8267 19.5663 48.9933 20.1774 49H49.8224C50.4335 48.9933 51.0321 48.8267 51.5589 48.5167C52.0856 48.2068 52.522 47.7644 52.8246 47.2334C53.1272 46.7025 53.2856 46.1015 53.2839 45.4904C53.2822 44.8793 53.1205 44.2792 52.8149 43.75L37.9924 19.005C37.6804 18.4907 37.2411 18.0655 36.7169 17.7703C36.1928 17.4752 35.6014 17.3202 34.9999 17.3202C34.3983 17.3202 33.8069 17.4752 33.2828 17.7703C32.7586 18.0655 32.3193 18.4907 32.0074 19.005Z'
      stroke='#DC6803'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
